<div class="watchlist-main-page">
    <!-- Empty State (when no watchlist/benchmark is selected) -->
    <div *ngIf="activeSection === 'watchlist' && (!userWatchlists || userWatchlists.length === 0) && !loading" 
         class="d-flex align-items-center justify-content-center" style="min-height: 70vh;">
        <div class="card shadow border-0" style="max-width: 400px; width: 100%;">
            <div class="card-body text-center p-4">
                <div class="mb-3">
                    <div class="d-inline-flex align-items-center justify-content-center rounded-circle text-white" 
                         style="width: 60px; height: 60px; background: linear-gradient(135deg, #b39cd0 0%, #7c6bb8 100%);">
                        <i class="material-icons">dashboard</i>
                    </div>
                </div>
                
                <h5 class="card-title text-dark mb-2 fw-bold">No watchlists yet</h5>
                <p class="card-text text-muted mb-3 small">
                    Create your first watchlist to start monitoring companies
                </p>
                
                <button class="btn btn-primary btn-sm px-3 py-2 " (click)="onCreateWatchlist()" style="display: inline-flex;align-items: center;">
                    <i class="material-icons me-1" style="font-size: 20px;">add</i>
                    Create Watchlist
                </button>
            </div>
        </div>
    </div>

    <!-- Empty State for Benchmarks -->
    <div *ngIf="activeSection === 'benchmark' && (!benchmarks || benchmarks.length === 0) && !selectedBenchmark && !loading" 
         class="d-flex align-items-center justify-content-center" style="min-height: 70vh;">
        <div class="card shadow border-0" style="max-width: 400px; width: 100%;">
            <div class="card-body text-center p-4">
                <div class="mb-3">
                    <div class="d-inline-flex align-items-center justify-content-center rounded-circle text-white" 
                         style="width: 60px; height: 60px; background: linear-gradient(135deg, #b39cd0 0%, #7c6bb8 100%);">
                        <i class="material-icons">assessment</i>
                    </div>
                </div>
                
                <h5 class="card-title text-dark mb-2 fw-bold">No benchmarks available</h5>
                <p class="card-text text-muted mb-3 small">
                    Benchmark portfolios will appear here once they are created by an administrator.
                </p>
            </div>
        </div>
    </div>

    <!-- Portfolio Content (when a watchlist or benchmark is selected) -->
    <div *ngIf="selectedWatchlist || selectedBenchmark" class="watchlist-content">
        <!-- Portfolio Header -->
        <div class="watchlist-header">
            <h1 class="watchlist-title">{{ getCurrentPortfolioName() }}</h1>
            <div class="action-buttons" *ngIf="!isReadOnly">
                <button class="btn btn-primary" (click)="onEditWatchlist(selectedWatchlist!); $event.stopPropagation()" *ngIf="selectedWatchlist" style="background:#E5E7EB;color:#1F2937;"

                >
                    Edit Watchlist
                </button>
                <button class="btn btn-primary" style="background:#1F3A8A;color:#FFFFFF;"
                (click)="onAddCompanies()" *ngIf="selectedWatchlist">
                    Add Companies
                </button>
                <button class="btn btn-primary" style="background:#64748B;color:#FFFFFF;"
                (click)="onUploadPortfolio()" *ngIf="selectedWatchlist">
                    Upload Portfolio
                </button>
            </div>
        </div>

        <!-- Benchmark Description (full width below header) -->
        <div *ngIf="selectedBenchmark?.description" class="benchmark-description-box">
            <p class="benchmark-description-text">
                {{ selectedBenchmark!.description }}
            </p>
        </div>

        <!-- Companies Table -->
        <app-watchlist-companies-table
            [companies]="watchlistCompanies"
            [loading]="loading"
            [isReadOnly]="isReadOnly"
            (updatedWatchlist)="onWatchlistUpdated()"
            >
        </app-watchlist-companies-table>
        
    <div style="font-size: 10px;margin-top:20px; margin-bottom:10px;">
        <span style="font-size: 10px;margin-top:20px; margin-bottom:10px;">
        Important Notice: 
This content is provided for general informational purposes only. It reflects a quantitative assessment of a company’s innovation activity based primarily on patent-related data and does not constitute investment advice, investment brokerage, portfolio management, a personal recommendation, or an offer or solicitation to buy, sell, or hold any security. The rating shown on this page, including any “BUY”, “HOLD”, or “SELL” label, is generated by a model using patent and related innovation signals only. It does not take into account any investor’s individual investment objectives, financial situation, tax position, liquidity needs, risk tolerance, existing holdings, or suitability requirements. The model does not incorporate all factors relevant to an investment decision, including valuation, financial performance, balance sheet strength, macroeconomic conditions, governance, litigation, competitive dynamics, or market sentiment. This content must not be used as the sole basis for any investment decision. 
     </span>
      </div>
    </div>

</div>